import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';


const MediaTypeInput = ({name, label, rules=null, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: "media_media_type_1",
    },
    {
      value: 2,
      label: "media_media_type_2",
    },
    {
      value: 3,
      label: "media_media_type_3",
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={rules}
        >
          <Select disabled={disabled}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default MediaTypeInput;
